import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import { CommonModule, formatDate } from "@angular/common";
import { MatChipsModule } from "@angular/material/chips";
import { ReactiveFormsModule, FormsModule, FormControl } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatRadioModule } from "@angular/material/radio";
import { MatNativeDateModule } from "@angular/material/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { GlobalVariablesService } from "../../../global.service";
import { SettingData } from "../../../models/settings.model";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { SharedService } from "../../../share-data/shared.service";
import { APIService } from "../../../fleet-management/backend-service/backend-service";
import { HttpResponse } from "@angular/common/http";
import { NotificationService } from '../../../shared/services/notification.service';
import { LoadingService } from '../../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: "app-report-predefind-add-new",
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatNativeDateModule,
    RouterLink,
    MatProgressSpinnerModule,
  ],
  templateUrl: "./report-predefind-add-new.component.html",
  styleUrl: "./report-predefind-add-new.component.scss",
})
export class ReportPredefindAddNewComponent implements OnDestroy {
  expenseAccount: string = "";
  expenseDesc: string = "";
  expenseAmount: string = "";
  expenseClass: string = "";
  lineClass: string = "";
  expenseBillableEntity: string = "";

  editOption: string[] = ["Yes", "No"];
  isAmountEditable: string = this.editOption[0];
  data: any;
  isEdit: string = "";
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private globalVariable: GlobalVariablesService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private apiService: APIService,
    private router: Router,
    private notification: NotificationService,
    public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      this.isEdit = params["isEdit"];
      if (this.isEdit == "true") {
        try {
          this.data = this.sharedService.getData();
          console.log("Share data:", this.data);
          this.expenseAccount = this.data["expenseAccount"];
          this.expenseDesc = this.data["expenseDesc"];
          this.expenseAmount = this.data["expenseAmount"];
          this.expenseClass = this.data["expenseClass"];
          this.lineClass = this.data["lineClass"];
          this.expenseBillableEntity = this.data["expenseBillableEnity"];
          this.isAmountEditable = this.data["isAmountEditable"] == true ? "Yes" : "No";

          this.cdr.detectChanges(); // Ensure changes are reflected
        } catch (error) {}
      }
    });
  }

  submitButtonAction() {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    if (this.expenseAccount.length < 1) {
      this.notification.warning('Please enter Khmer Name')
      return;
    }
    if (this.expenseAmount.length < 1) {
      this.notification.warning('Please enter English Name')
      return;
    }
    if (this.expenseBillableEntity.length < 1) {
      this.notification.warning('Please enter NID Number')
      return;
    }
    if (this.expenseDesc.length < 1) {
      this.notification.warning('Please select gender')
      return;
    }
    if (this.expenseClass.length < 1) {
      this.notification.warning('Please enter Email')
      return;
    }
    if (this.lineClass.length < 1) {
      this.notification.warning('Please enter Username')
      return;
    }
    let jsonData: any = {
      "expenseAccount": this.expenseAccount,
      "expenseDesc": this.expenseDesc,
      "expenseAmount": parseFloat(this.expenseAmount),
      "expenseBillableEnity": this.expenseBillableEntity,
      "expenseClass": this.expenseClass,
      "lineClass": this.lineClass,
      "isAmountEditable": this.isAmountEditable == "Yes" ? true : false,
    }
    console.log("User data: ", jsonData)
    let endpoint = '';
    if (this.isEdit == 'true') {
      endpoint = '/api/predefined-expenses/' + this.data["id"];
      this.apiService.put(endpoint, jsonData, loginData.token)
        .subscribe({
          next: (response: HttpResponse<any>) => {
            console.log('HTTP Status:', response.status);
            console.log('/api/predefined-expenses/' + ',\n' + 'Edit_Response:', response.body);

            if (response.status === 200) {
              this.notification.success('Update successfully');
            }
            else {
              this.notification.error('Update failed. Please try again.');
            }
            this.router.navigate(['/home/settings/report-predefind-data']);
          },
          error: err => {
            console.error('Error:', err);
          }
        });
    }
    else {
    console.log("User data: ", jsonData)
      endpoint = '/api/predefined-expenses/register';
      try {
        this.apiService.post(endpoint, jsonData, loginData.token).subscribe({
        next: response => {
          console.log('HTTP Status:', response.status);
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Create successfully');
          }
          else {
            this.notification.error('Create failed. Please try again.');
          }
          this.router.navigate(['/home/settings/report-predefind-data']);
        },
        error: error => {
          console.error('Error:', error);
        }
      });
      } catch (error) {
        this.notification.error(`Create failed: ${error}`);
      }
    }
    console.log("endpoint: ", endpoint)
  }
}
